import DOMPurify from "dompurify";

export function GetVar(variable) {
  const searchParams = new URLSearchParams(window.location.search);
  const value = searchParams.get(variable) ?? "";
  return DOMPurify.sanitize(value);
}
